module.exports = __webpack_public_path__ + "media/BIRD.1fd29528.mp3";